import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header, Footer } from '../components/HomePage';
import PrivacyPolicy from '../components/HomePage/Footer/PrivacyPolicy';

function PrivacyPolicyPage() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Circledin - Your Privacy Matters</title>
        <meta 
          name="description" 
          content="Read Circledin's Privacy Policy. Learn how we collect, use, and protect your personal information when using our mobile plan group discount platform." 
        />
        <meta name="keywords" content="privacy policy, data protection, personal information, circledin, mobile plans, privacy rights, CCPA, data security" />
        <meta name="robots" content="index, follow" />
        
        {/* Open Graph meta tags */}
        <meta property="og:title" content="Privacy Policy | Circledin - Your Privacy Matters" />
        <meta property="og:description" content="Learn how Circledin protects your privacy and personal information. Comprehensive privacy policy with clear data practices." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://circledin.com/privacy-policy" />
        
        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Privacy Policy | Circledin - Your Privacy Matters" />
        <meta name="twitter:description" content="Learn how Circledin protects your privacy and personal information. Comprehensive privacy policy with clear data practices." />
        
        {/* Additional Privacy-Specific Meta Tags */}
        <meta name="privacy-policy" content="https://circledin.com/privacy-policy" />
        <meta name="data-protection" content="CCPA, CPRA, GDPR compliant" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://circledin.com/privacy-policy" />
        
        {/* Additional SEO Meta Tags */}
        <meta name="author" content="Circledin, Inc." />
        <meta name="publisher" content="Circledin, Inc." />
        <meta name="copyright" content="© 2025 Circledin, Inc." />
        <meta name="language" content="EN" />
        <meta name="revisit-after" content="30 days" />
        
        {/* Schema.org Structured Data for Privacy Policy */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Privacy Policy",
            "description": "Circledin's Privacy Policy explaining how we collect, use, and protect personal information.",
            "url": "https://circledin.com/privacy-policy",
            "inLanguage": "en-US",
            "isPartOf": {
              "@type": "WebSite",
              "name": "Circledin",
              "url": "https://circledin.com"
            },
            "author": {
              "@type": "Organization",
              "name": "Circledin, Inc.",
              "url": "https://circledin.com"
            },
            "datePublished": "2025-01-01",
            "dateModified": "2025-01-01",
            "mainEntity": {
              "@type": "PrivacyPolicy",
              "name": "Circledin Privacy Policy",
              "version": "3.0",
              "effectiveDate": "2025-01-01",
              "publisher": {
                "@type": "Organization",
                "name": "Circledin, Inc."
              }
            }
          })}
        </script>
      </Helmet>
      
      <Header />
      <PrivacyPolicy />
      <Footer />
    </>
  );
}

export default PrivacyPolicyPage;